export default {"src":"/frontend-static/_next/static/media/appStoreFr.b7618917.svg","height":40,"width":127,"blurWidth":0,"blurHeight":0};